import { Component } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { StatusEnum } from '@enums/Status';
import { Estimate } from '@interfaces/Estimate';
import { DataManagementService } from '../shared/data-management.service';

@Component({
  selector: 'pop-export-to-gp-sifia',
  templateUrl: './export-to-gp-sifia.component.html',
  styleUrls: ['./export-to-gp-sifia.component.less']
})
export class ExportToGpSifiaComponent extends BaseComponent {
  public resultsList: {
    titleKey: string;
    routerLink: string[];
    referenceCode: string;
  }[] = [];

  public selectedEstimate?: Estimate;

  public constructor(private dataManagementService: DataManagementService) {
    super();
  }

  public async exportToGpSifia() {
    if (this.selectedEstimate) {
      await this.dataManagementService.exportToGpSifia(this.selectedEstimate);
      let code: string;
      if (this.selectedEstimate.codeRef) {
        code = `${this.selectedEstimate.projectCode} ${this.selectedEstimate.codeRef}`;
      } else {
        code = this.selectedEstimate.projectCode;
      }
      this.resultsList.push({
        titleKey: 'DATA_MANAGEMENT.EXPORT_SUCCESS',
        routerLink: this.getEstimateRoute(this.selectedEstimate.id),
        referenceCode: code
      });
      this.selectedEstimate = undefined;
    }
  }
  public getEstimateRoute(estimateId?: string) {
    const routerLink = ['/app/', 'estimate-detail', estimateId];
    return routerLink;
  }
  public filterEstimates = ((dto: Estimate) => {
    return dto.status === StatusEnum.Waiting;
  }).bind(this);
}
